import { actionTypes } from '../actionTypes/actionTypes';

export const updatePlan = ( payload:any ) => ({
    type: actionTypes.updatePlan,
    payload
});
